export function getFadeUpAnimationGroups() {
    const nodes = Array.from(document.querySelectorAll('.animation-fade-up'));
    let groupedNodes = {};
    let ungroupedNodes = [];
    
    nodes.forEach((node) => {
        const regex = /animation\-fade-up\-\-([^\s]+)/i;
        let groupName;
        for (const className of node.classList) {
            let matches = className.match(regex);
            if (matches && matches.length > 1) {
                groupName = matches[1];
                break;
            }
        }

        if (groupName) {
            if (!groupedNodes[groupName]) {
                groupedNodes[groupName] = [];
            }
            groupedNodes[groupName].push(node);
        } else {
            ungroupedNodes.push(node);
        }
    })

    return [...ungroupedNodes, ...Object.values(groupedNodes)];
}

export function doFadeUpAnimationGroup(nodes, delayInterval = 0, animationDuration = 0) {
    let delay = 0;

    if (Array.isArray(nodes)) {
        for (let node of nodes) {
            setTimeout(function () {
                node.classList.add('animating')
                setTimeout(function () {
                    node.classList.remove('animating')
                    node.classList.add('animated')
                }, animationDuration)
            }, delay)
            delay += delayInterval;
        }
    } else {
        setTimeout(function () {
            nodes.classList.add('animating')
            setTimeout(function () {
                nodes.classList.remove('animating')
                nodes.classList.add('animated')
            }, animationDuration)
        }, delay)
    }
}